import {useState, useEffect} from 'react';
import {lstorage} from 'utils/lstorage.js';
import startaudiocontext from 'startaudiocontext';
import {LOW_SAMPLE_RATE} from 'constants/sample-rates.js';
import {checkLocalProjects} from "utils/checkLocalProjects.js";
import Tone from 'tone';
import {setupDropFiles} from '../DropFiles.js';
import KeyboardEngine from 'keyboard/KeyboardEngine';
import EthereumCache from 'decentralized/cache/EthereumCache.js';
import ethereum from 'decentralized/ethereum.js';
import accounts from 'accounts/Accounts.js';
import EthereumSoundsSearcher from 'search/EthereumSoundsSearcher.js';
import ScriptableSequencer from 'engine/ScriptableSequencer.js';
import Scripting from 'scripting/Scripting.js';

var AudioContext = window.AudioContext || window.webkitAudioContext;

export const useSequencer = (props, contextLoaded=true) => {
    console.log("use sequencer started");
    let [ethereumCache, setEthereumCache] = useState(new EthereumCache(props.store));
    let [ethereumSearcher, setEthereumSearcher] = useState(undefined);
    let [sequencerEngine, setSequencerEngine] = useState(undefined);

    useEffect(() => {
        if (!contextLoaded) {
            return;
        }
        var root = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)

        root.setAttribute( 'class', 'bad-scroll' );

        if (!props.skipSampleRate) {
            if (!window.isNFT && lstorage.getItem("sampleRate")) {
                Tone.setContext(new AudioContext({
                    // latencyHint: "playback",
                    sampleRate: parseFloat(lstorage.getItem("sampleRate"))}));
            } else {
                Tone.setContext(new AudioContext(
                    {
                        // latencyHint: "playback",
                        sampleRate: LOW_SAMPLE_RATE
                    }));
           }

            if (!window.isNFT) {
                accounts.setStore(props.store);
                accounts.setEthereum(ethereum);
                accounts.checkLogin()
                    .then(() => {
                        ethereum.guilds.initGuilds();
                        ethereum.guilds.acceptAnyNewRequests();
                        accounts.appear();
                });
            }
        }

        startaudiocontext(Tone.Master.context, ".exhibit");
        
        checkLocalProjects();
        ethereum.cache = ethereumCache;
        ethereum.cache.loadIndex();
        
        ethereum.store = props.store;
        ethereum.crypto.store = props.store;

        let engine = new ScriptableSequencer(props.store);
        engine.setScripting(new Scripting(engine));
        engine.connectToKeyboardEngine(new KeyboardEngine(engine));
        engine.ethereumCache = ethereumCache;
        setEthereumSearcher(new EthereumSoundsSearcher(ethereumCache, engine));
        if (props.setSequencerEngine) {
            props.setSequencerEngine(engine);
        }
        setSequencerEngine(engine);

        window.addEventListener("beforeunload", (event) => {
            event.returnValue = "Please dont leave";
            return event;
        });

        let sequenceId = sequencerEngine !== undefined ?
            props.sequencerEngine.getSequenceId() :
            props.match && props.match.params.sequenceId != undefined ? 
            props.match.params.sequenceId :
        null;

        /*
        window.projectId = "QmbUTc8CQ2w44kaTLAfSni1eYNXHhhC4VEbniWkzHSwokn";
        //window.isNFT = true;
        window._isNFT = true;
        */

        if (window.projectId) {
            engine.loadSequence(window.projectId);
        } else if (sequenceId == null) {
            engine.loadNewSequence();
        } else {
            engine.loadSequence(sequenceId);
        }

        setupDropFiles(engine);
    }, [contextLoaded]);

    console.log('use sequence ended');
    return [ethereumCache, sequencerEngine, ethereumSearcher];
};
